// extracted by mini-css-extract-plugin
export var bodySections = "_cy-8";
export var gray = "_cy-7";
export var green = "_cy-4";
export var iconContainer = "_cy-9";
export var iconWidgetContainer = "_cy-1";
export var phoneIcon = "_cy-2";
export var red = "_cy-5";
export var statusDot = "_cy-3";
export var widgetContainer = "_cy-0";
export var yellow = "_cy-6";